import { render, staticRenderFns } from "./WorkInProgress.vue?vue&type=template&id=c4efcaae&scoped=true&lang=html&"
import script from "./WorkInProgress.vue?vue&type=script&lang=js&"
export * from "./WorkInProgress.vue?vue&type=script&lang=js&"
import style0 from "./WorkInProgress.vue?vue&type=style&index=0&id=c4efcaae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4efcaae",
  null
  
)

export default component.exports